import { Editor } from "@tinymce/tinymce-react";

interface HtmlEditorProps {
    value: string;
    onChange: (value: string) => void;
}

export default function HtmlEditor({ value, onChange }: HtmlEditorProps) {
    return (
        <Editor
            apiKey={process.env.REACT_APP_TINYMCE_API_KEY}
            value={value}
            onEditorChange={onChange}
            init={{
                height: 350,
                menubar: false,
                branding: false,
                plugins: [
                    "lists",
                    "link",
                    "autolink",
                    "codesample",
                    "code",
                    "preview"
                ],
                toolbar:
                    "undo redo | bold italic underline | bullist numlist | link | code preview",
                content_style:
                    "body { font-family: Roboto, sans-serif; font-size: 14px; padding: 10px; }"
            }}
        />
    );
}
